

import { Grid } from "@mui/material";
import { useUsuariosTodosRol } from "../../../hooks";
import { DisenioPaginas } from "../../layout";
import { BuscadorSoloValor, CargandoMedio, TablaListadoUsuarios } from "../../components";




export const ListadoClientes = () => {


    const { todoUsuariosQuery, page, chagePage, termino, chageTermino } = useUsuariosTodosRol(['CLIENTE',])



    return (

        <DisenioPaginas titulo="Listado de Clientes" url="add/user">
            <Grid container sx={{mt:5}}>
                {(todoUsuariosQuery.isLoading)
                ?   <CargandoMedio titulo="Cargando Usuarios..." />
                :   <>
                    <BuscadorSoloValor termino={ termino } chageTermino={chageTermino} 
                        titulo='Buscar usuario...' place='Buscar x nombre cedula o email...'
                    />
                    <TablaListadoUsuarios data={todoUsuariosQuery.data || []} chagePage={chagePage} page={page} />
                    </>
                }
            </Grid>
        </DisenioPaginas>
    )
}
